import useDialog from '@hooks/useDialog';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { closeOptions } from '@utils/utils';
import { createElement } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import UploadContacts from './UploadContacts';

const useContactsUpload = () => {
    const { t } = useTranslation();
    const dialog = useDialog();
    const queryClient = useQueryClient();
    const { control, getValues, reset } = useForm();

    const uploadContactsMutation = useMutation({
        mutationKey: ['uploadContacts'],
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['contacts'] });
            dialog.close();
            closeOptions();
        },
    });

    const handleContactsUpload = () => {
        reset();
        dialog.open({
            title: t('prompts:title.importContacts'),
            content: createElement(UploadContacts, { control }),
            confirmLabel: t('prompts:confirm.import'),
            confirmButtonProps: {
                variant: 'filled',
            },
            mutationKey: ['uploadContacts'],
            confirmMutation: uploadContactsMutation,
            onConfirm: getValues,
        });
    };

    return handleContactsUpload;
};

export default useContactsUpload;
